module.exports = __webpack_public_path__ + "img/1437859766.22b0b4bb.jpg";